import LoginButton from './login_button'
import { connect } from 'react-redux'

import {
  logoutUrlSelector,
  loginUrlSelector,
  isLoggedInSelector,
} from 'redux/selectors/login'

const mapStateToProps = (state, ownProps) => {
  const returnPath = ownProps.stayOnPageOnLogout
    ? { returnUri: window.location.href }
    : undefined
  return {
    displayName: state.current_user.full_name,
    loggedIn: isLoggedInSelector(state),
    loginUrl: loginUrlSelector({ returnUri: window.location.href })(state),
    logoutUrl: logoutUrlSelector(returnPath)(state),
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginButton)
